export const PLAYLIST_GENRES = 'PLAYLIST_GENRES';
export const BRANDS = 'BRANDS';
export const PRODUCT_TYPE = 'PRODUCT_TYPE';
export const PRODUCT_SKU = 'PRODUCT_SKU';
export const SHIPPING_CATEGORIES = 'SHIPPING_CATEGORIES';
export const PRICE_LISTS = 'PRICE_LISTS';
export const STOCK_LOCATIONS = 'STOCK_LOCATIONS';
export const REMOVE_PRODUCT_SKU = 'REMOVE_PRODUCT_SKU';
